import { useSyncExternalStore } from 'react'

export type ColorScheme = 'light' | 'dark'

function getSnapshot(): ColorScheme {
  return typeof document !== 'undefined' &&
    document.documentElement.classList.contains('dark')
    ? 'dark'
    : 'light'
}

// SSR / non-DOM environments have no theme to read; default to light.
function getServerSnapshot(): ColorScheme {
  return 'light'
}

function subscribe(onStoreChange: () => void): () => void {
  if (typeof document === 'undefined') return () => {}
  const observer = new MutationObserver(onStoreChange)
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
  })
  return () => observer.disconnect()
}

/**
 * Resolved colour scheme, read from the `dark`/`light` class that
 * `PopcornProvider` toggles on `<html>`. The charts resolve colours imperatively
 * from CSS custom properties via `getComputedStyle` (captured at render time);
 * this hook re-renders when the class flips so the values are re-read for the new
 * theme. Reading the DOM class directly (not `useTheme`) also works in the
 * provider-less offscreen render used by the chart-share snapshot.
 */
export function useDocumentColorScheme(): ColorScheme {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
